import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'roles'
let doc = {
  list: {
    name: 'Roles',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
    ],
  },

  form: {},

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
